import type React from "react";

import Message from "@components/Message";
import { FaqLinkComponent } from "@components/FaqLink/FaqLinkComponent";
import { Popover } from "@components/Popover/PopOver";

import { type VerificationService } from "@/lib/types/types";

import { useSegment } from "@/lib/state/contextHooks";

interface HowDoesVerifyingWorkProps {
  verificationService: VerificationService;
  initialVisibility?: boolean;
}

const HowDoesVerifyingWorkComponent: React.FC<HowDoesVerifyingWorkProps> = ({
  verificationService,
  initialVisibility = false,
}: HowDoesVerifyingWorkProps) => {
  const segment = useSegment();

  return (
    <Popover
      initialVisibility={initialVisibility}
      trigger={
        <button
          type="button"
          className="sid-h-btn-link-like sid-link sid-how-does-verifying-work-hoverable"
        >
          <Message id="howDoesVerifyingWork" />
        </button>
      }
      message={
        <div>
          <Message id="step.personalInfo.howDoesVerifyingWorkDetails" context={segment} />
          &nbsp;
          <FaqLinkComponent verificationService={verificationService} />
        </div>
      }
    />
  );
};

export { HowDoesVerifyingWorkComponent };
